export const fr = {
    "name": "fr",
    "options": {
      "months": [
        "janvier",
        "février",
        "mars",
        "avril",
        "mai",
        "juin",
        "juillet",
        "août",
        "septembre",
        "octobre",
        "novembre",
        "décembre"
      ],
      "shortMonths": [
        "janv.",
        "févr.",
        "mars",
        "avr.",
        "mai",
        "juin",
        "juill.",
        "août",
        "sept.",
        "oct.",
        "nov.",
        "déc."
      ],
      "days": [
        "dimanche",
        "lundi",
        "mardi",
        "mercredi",
        "jeudi",
        "vendredi",
        "samedi"
      ],
      "shortDays": ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."],
      "toolbar": {
        "exportToSVG": "Télécharger au format SVG",
        "exportToPNG": "Télécharger au format PNG",
        "exportToCSV": "Télécharger au format CSV",
        "menu": "Menu",
        "selection": "Sélection",
        "selectionZoom": "Sélection et zoom",
        "zoomIn": "Zoomer",
        "zoomOut": "Dézoomer",
        "pan": "Navigation",
        "reset": "Réinitialiser le zoom"
      }
    }
  }

export const it = {
    "name": "it",
    "options": {
      "months": [
        "gennaio",
        "febbraio",
        "marzo",
        "aprile",
        "maggio",
        "giugno",
        "luglio",
        "agosto",
        "settembre",
        "ottobre",
        "novembre",
        "dicembre"
      ],
      "shortMonths": [
        "gen",
        "feb",
        "mar",
        "apr",
        "mag",
        "giu",
        "lug",
        "ago",
        "set",
        "ott",
        "nov",
        "dic"
      ],
      "days": [
        "domenica",
        "lunedì",
        "martedì",
        "mercoledì",
        "giovedì",
        "venerdì",
        "sabato"
      ],
      "shortDays": ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
      "toolbar": {
        "exportToSVG": "Esporta come SVG",
        "exportToPNG": "Esporta come PNG",
        "exportToCSV": "Esporta come CSV",
        "menu": "Menu",
        "selection": "Selezione",
        "selectionZoom": "Zoom sulla selezione",
        "zoomIn": "Ingrandisci",
        "zoomOut": "Riduci",
        "pan": "Sposta",
        "reset": "Reimposta zoom"
      }
    }
  }
